import { useRef, useContext } from 'react';

import { GlobalContext } from "../../contexts/globalContext";
import styles from './ShutdownButton.module.css';

const ShutdownButton = ({ showContent }) => {

    const ref = useRef();
    const { localSocketRef } = useContext(GlobalContext);

    const click_handler = async () => {
        if (window.confirm("Ești sigur că vrei să inchizi aplicatia?")) {
            if (localSocketRef.current?.connected) {
                localSocketRef.current.emit("systemInfo:shutdown");
            }
        }
    }

    return (
        <div ref={ref} className={styles.component} onClick={() => click_handler()} style={{ display: showContent ? "flex" : "none" }}>
            <i className={styles.icon + " fa-solid fa-power-off"}></i>

            <div className={styles.text}>POWER OFF</div>
        </div>
    );
}

export default ShutdownButton;